import { render, staticRenderFns } from "./OfflineAlert.vue?vue&type=template&id=8f7ef2a6&lang=pug&"
import script from "./OfflineAlert.vue?vue&type=script&lang=ts&"
export * from "./OfflineAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports